const __WEBPACK_NAMESPACE_OBJECT__ = require("plugin-assets/shared/components/color-dropdown-options");